import React, { createContext, useContext, useState } from "react";
import Toast from "../components/toast/Toast";
import { ToastProps } from "../types";

type ToastContextType = {
  displayMessage(msg: string, type: string): void;
};

const ToastContext = createContext<ToastContextType | null>(null);

type ToastProviderProps = {
  children: React.ReactNode;
};

export function ToastProvider({ children }: ToastProviderProps) {
  const [toastData, setToastData] = useState<ToastProps>({
    message: "",
    type: "",
  });

  const resetToast = () => {
    setToastData({ message: "", type: "" });
  };

  const displayMessage = (
    msg: string,
    type: "success" | "warning" | "error" | ""
  ) => {
    setToastData({ message: msg, type });
    setTimeout(resetToast, 3000);
  };

  const displayToast = () => {
    if (toastData.message)
      return (
        <Toast
          message={toastData.message}
          type={toastData.type}
          resetToast={resetToast}
        />
      );
    else return null;
  };

  return (
    <ToastContext.Provider value={{ displayMessage }}>
      <>
        {children} {displayToast()}
      </>
    </ToastContext.Provider>
  );
}

export const useToast = () => {
  return useContext(ToastContext);
};
